"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormulaEngine = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const HyperEngine_1 = require("./HyperEngine");
/**
 * Creates a formula engine for a given version and given array of formulas
 * @param engineVersion
 * @returns {FormulaEngine} which provides function(s) to evaluates given formulas.
 */
const createFormulaEngine = (engineVersion, formulas, f1EngineMode) => {
    switch (engineVersion) {
        case finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1:
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1:
            return (0, HyperEngine_1.initialize)(formulas, f1EngineMode);
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.ExcelEngine1:
            throw new common_1.error.FinleyError(`"${engineVersion}" is not yet supported`);
        default:
            return (0, common_1.finleyAssertUnreachable)(engineVersion);
    }
};
exports.createFormulaEngine = createFormulaEngine;
//# sourceMappingURL=create.js.map